import { render } from "./pluginPropEdit.vue?vue&type=template&id=179723d8&scoped=true&ts=true"
import script from "./pluginPropEdit.vue?vue&type=script&lang=ts"
export * from "./pluginPropEdit.vue?vue&type=script&lang=ts"

import "./pluginPropEdit.vue?vue&type=style&index=0&id=179723d8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179723d8"]])

export default __exports__